import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import sessionStore from '../stores/SessionStore';

const ProtectedRoute: React.FC<{ redirectPath?: string }> = observer(({ redirectPath = '/login' }) => {
  const location = useLocation();

  // While session hydration is in progress, render nothing visible but avoid
  // a premature redirect to /login (which would cause a flash).
  // The withSessionHydration HOC already shows its own "Loading session…"
  // screen, so this branch is only hit if the tree renders before hydration
  // completes (e.g. Clerk loaded fast but Django validation is still pending).
  if (sessionStore.isLoading) {
    return null;
  }

  if (!sessionStore.isAuthenticated) {
    return <Navigate replace state={{ from: location }} to={redirectPath} />;
  }

  return <Outlet />;
});

export default ProtectedRoute;
